module.exports = "/images/a62292a3d1a9546b0d819e974a2ab89c.svg";